<template>
  <div class="editGallery">
    <div class="topBar">
      <div class="subTitle"><i class="far fa-window-minimize" style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"></i>新建品牌</div>
    </div>
    <div style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">编辑品牌</div>
      </div>
      <div class="table">
        <div class="form">
          <div class="row">
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">品牌名称:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="name"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">主要产品:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="main_products"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="row">
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">所属国别:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="country"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="row">
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">品牌官网:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="website"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="row">
            <el-row >
              <el-col :span="5">
                <div class="grid-content label">logo缩略图:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <input
                    class="ipt_fil"
                    placeholder="选择上传文件"
                    type="file"
                    name="img"
                    accept="img/png, img/jpeg, img/jpg"
                    @change="getImage1($event)"
                    style="margin-bottom: 10px"
                  >
                  <div class="notice">只能上传png/jpg格式文件,文件大小不能超过50KB</div>
                </div>
              </el-col>
          </el-row>
          </div>
         
          <div class="row">
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">品牌logo:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <input
                    type="file"
                    name="image"
                    accept="image/png, image/jpeg, image/jpg"
                    @change="getImage($event)"
                    style="margin-bottom: 10px"
                  >
                  <div class="notice">图片必须为jpg或png合适，且大小不能超过5mb</div>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">是否显示:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-switch
                    @change="up_down(id)"
                    v-model="show"
                    active-text="显示"
                    inactive-text="不显示"
                    active-value="1"
                    inactive-value="0"
                  ></el-switch>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">排序:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="order_by"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="6">
                <div class="grid-content label">品牌描述:</div>
              </el-col>
              <el-col :span="30">
                <div class="grid-content input">
                  <wanged-itor :info='info' @change_edit='change_edit'></wanged-itor>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="row" align="center">
            <div class="grid-content input">
              <button class="button" @click="submit()">提交</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import WangedItor from "../components/wangeditor";
export default {
   components: {
    WangedItor
  },
  name: "editGallery",
  data() {
    return { serve: this.$store.state.serve,
      wang_info:null,
      id: "",
      name: "",
      info: "",
      image: null,
      image1: null,
      galleryId: this.$route.params.id,
      main_products: "",
      show: "",
      order_by: "",
      website: "",
      country: "",
      username: this.$cookies.get('username'),
      token: this.$cookies.get('token'),
    };
  },
  created() {
   
    this.$store.state.topActiveId = 2;
    this.$store.state.leftTitle = "品牌管理";
    var that = this;
    this.axios
      .get(this.serve+"/admin/get_brand_info", {
        params: { id: this.galleryId ,username: this.username, token: this.token}
      })
      .then(function(res) {
        that.country = res.data.country;
        that.website = res.data.website;
        that.id = res.data.id;
        that.name = res.data.name;
        that.info = res.data.info;
        that.main_products = res.data.main_products;
        that.order_by = res.data.order_by;
        that.show = res.data.show;
      })
      .catch(function(err) {
        alert("操作失败");
      });
  },
  mounted() {},
  methods: {
    change_edit(data){
      this.wang_info = data
    },
    handimg(file ,Editor ,cursorLocation ,resetUploader ){
       let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      var formData = new FormData()
      formData.append('img',file)
      formData.append('username',this.username)
      formData.append('token',this.token)
      this.axios.post(this.serve+'/admin/edit_upload_img',formData,config).then(res=>{
        Editor.insertEmbed(cursorLocation, "image", res.data.data);
        resetUploader();
      })
    },
    getImage(e) {
      this.image = e.target.files[0];
    },
    getImage1(e) {
      this.image1 = e.target.files[0];
    },
    up_down(id) {
      this.axios.get(this.serve+"/admin/show_brand", {
        params: {
          id: id,
          token : this.token,
          username : this.username,
        }
      });
    },
    submit() {
      if (this.name == "") {
        alert("未填写品牌名称");
        return;
      }
     
      let formData = new FormData();
      formData.append("id", this.galleryId);
      formData.append("name", this.name);
      formData.append("logo", this.image);
      formData.append("logo_thumb", this.image1);
      if(this.wang_info === null){
        formData.append("info", this.info);
      }else{
        formData.append("info", this.wang_info);
      }
      
      formData.append("main_products", this.main_products);
      formData.append("show", this.show);
      formData.append("order_by", this.order_by);
      formData.append("username", this.username);
      formData.append("token", this.token);
      formData.append("website", this.website);
      formData.append("country", this.country);

      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };

      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      var that = this;
      // return
      this.axios
        .post( 
          this.serve+"/admin/change_brand_info",
          formData,
          config
        )
        .then(function(res) {
          if(res.data.status == 'success'){
            loading.close();
            that.$router.push("/admin/brand");
            that.$message({
              type:"success",
              message : '上传成功'
            })
          }else if(res.data.code == '403'){
            that.$message.error(res.data.msg);
          } else if(res.data.status == 'error'){
            that.$message.error('上传失败')
            loading.close();
          }
         
        })
        .catch(function(err) {
          loading.close();
          alert("操作失败");
        });
    }
  }
};
</script>
<style lang="scss">
.editGallery {
  background: #f5f5f5;
  color: #333;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
  .input {
    width: 100%;
  }
  textarea {
    height: 300px;
  }
  .form-title {
    background-color: #eee;
    border: 1px solid #ddd;
  }
  .table {
    background-color: #fff;
  }
  .row {
    margin-bottom: 20px;
  }
  .form {
    width: 450px;
    margin: 0 auto;
    padding: 20px 0;
  }
  .label {
    line-height: 40px;
  }
  .notice {
    font-size: 13px;
    color: #666;
  }
}
</style>
